<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DNode } from './O3DNode'
export default {
  mixins: [O3DNode]
}
</script>

<style>
</style>
